import type { ShadowFloor } from "../../types/location-map";

import { getRefId } from "./installation-ids";
import { sortFloorsForList } from "./location-map-utils";

/** Select value for a zone that is not assigned to a floor. */
export const NO_FLOOR_ID = "none";

export const floorsForInstallation = (
	floors: readonly ShadowFloor[],
	installationId: string | undefined,
): ShadowFloor[] => {
	if (!installationId) return [];
	return sortFloorsForList(
		floors.filter((floor) => getRefId(floor.installation) === installationId),
	);
};
